import React__default from "react";
const CarouselContext = React__default.createContext({
  scrollToSlide: (
    /* istanbul ignore next */
    () => null
  ),
  isSlideVisible: (
    /* istanbul ignore next */
    () => false
  )
});
export {
  CarouselContext
};
